import React from 'react';

export const HOME_PAGE = {
  CARD_1: {
    H1: 'Pay with Bank Transfer',
    P0: 'Pay with Bank Transfer is a quick way to pay your Amex bill when logged in to your online account.',
    ITEM1: {
      TITLE: 'What is Pay with Bank Transfer?',
      P1: 'Pay with Bank Transfer lets you pay your Amex bill directly from your chosen bank account. Each time you make a payment:',
      LI1: 'You choose when to pay',
      LI2: 'You choose how much to pay',
      LI3: 'You approve your payment in your banking app',
      P2: 'It is easy to use and your payments are highly secure - your log in details are never shared and you never have to enter your account details.',
    },
    ITEM2: {
      TITLE: 'Why set up a Permission?',
      P1: 'Setting up a Permission means that when you start a payment you don\'t need to approve it in your banking app. With a Permission:',
      LI1: 'You still start every payment yourself',
      LI2: 'Nothing is paid unless you choose to make a payment',
      LI3: 'Your bank may ask you to approve some payments, depending on the limits you set',
      LI4: 'You can change or cancel your Permission at any time',
    },
    ITEM3: {
      TITLE: 'What are the benefits of setting up a Permission?',
      P1: 'Fast and simple to set up',
      P2: 'Fewer steps to make your payment',
      P3: 'Secure',
    },
  },
  CARD_2: {
    H1: 'How this works',
    H2: 'You stay in control - this permission simply makes paying your bill easier.',
    ITEM1: {
      TITLE: 'Create your Permission',
      P: 'Choose your bank, set your payment limits, and choose how long your permission should last. We will securely share this information to your bank',
    },
    ITEM2: {
      TITLE: 'Approve at your bank',
      P: 'You\'ll be sent to your bank app or online banking to approve the Permission. This confirms:',
      LI1: 'You want to use Pay with Bank Transfer',
      LI2: 'The limits and duration you\'ve chosen',
    },
    ITEM3: {
      TITLE: 'Make a payment',
      P1: 'When you want to pay your Amex bill:',
      LI1: 'Log in to your online Amex account',
      LI2: 'Choose Pay with Bank Transfer',
      LI3: 'Enter the amount you want to pay',
      P2: 'For most payments, you won\'t need to log into your bank again',
    },
  },
  BUTTON_PRIMARY: 'Create Permission',
  FAQ: (link) => (
    <>
      Need more information? Visit our&nbsp;
      <a href={link}>Frequently Asked Questions</a>
    </>
  ),
};
